module.exports = __webpack_public_path__ + "img/middle-OnRamp.713f2918.png";